import { useTranslation } from 'react-i18next'
import {
  Hero,
  TwoColumnsBlock,
  ProductShowcase,
  FullTextWithBgImage,
} from '@/components/sections'
import { Prefooter, Footer } from '@/components/layout'
import { getLocalizedPath } from '@/i18n/routes'

export function HomePage() {
  const { t, i18n } = useTranslation('common')
  const storeLocatorPath = getLocalizedPath('storeLocator', i18n.language as 'it' | 'en')
  const worldPath = getLocalizedPath('world', i18n.language as 'it' | 'en')
  const productsHairPath = getLocalizedPath('productsHair', i18n.language as 'it' | 'en')

  return (
    <main>
      <Hero />

      <TwoColumnsBlock
        chapter={t('home.brand.chapter')}
        eyebrow={t('home.brand.eyebrow')}
        titleLine1={t('home.brand.titleLine1')}
        titleLine2={t('home.brand.titleLine2')}
        body={t('home.brand.body')}
        ctaLabel={t('home.brand.ctaLabel')}
        ctaHref={worldPath}
        image="/images/nashi-world-home-fragrance.webp"
        imageAlt={t('home.brand.imageAlt')}
        caption={t('home.brand.caption')}
        bgTone="cream-soft"
      />

      <ProductShowcase viewAllHref={productsHairPath} />

      <FullTextWithBgImage
        image="/images/nashi-argan-natural.jpg"
        imageAlt={t('home.nature.imageAlt')}
        eyebrow={t('home.nature.eyebrow')}
        titleLine1={t('home.nature.titleLine1')}
        titleLine2={t('home.nature.titleLine2')}
        titleLine3={t('home.nature.titleLine3')}
        body={t('home.nature.body')}
        ctaLabel={t('home.nature.ctaLabel')}
        ctaHref={worldPath}
        height="cinematic"
        align="center"
      />

      <TwoColumnsBlock
        chapter={t('home.salon.chapter')}
        eyebrow={t('home.salon.eyebrow')}
        titleLine1={t('home.salon.titleLine1')}
        titleLine2={t('home.salon.titleLine2')}
        body={t('home.salon.body')}
        ctaLabel={t('home.salon.ctaLabel')}
        ctaHref={storeLocatorPath}
        image="/images/nashi-salon-experience.jpg"
        imageAlt={t('home.salon.imageAlt')}
        caption={t('home.salon.caption')}
        reverse
        bgTone="cream-soft"
      />

      <TwoColumnsBlock
        chapter={t('home.welcomeBox.chapter')}
        eyebrow={t('home.welcomeBox.eyebrow')}
        titleLine1={t('home.welcomeBox.titleLine1')}
        titleLine2={t('home.welcomeBox.titleLine2')}
        body={t('home.welcomeBox.body')}
        ctaLabel={t('home.welcomeBox.ctaLabel')}
        ctaTo="welcomeBox"
        image="/images/welcome-box.jpg"
        imageAlt={t('home.welcomeBox.imageAlt')}
        caption={t('home.welcomeBox.caption')}
      />

      <Prefooter />
      <Footer />
    </main>
  )
}
